import type { PropertyPreviewProps } from "@firecms/core";

import type { LocalizedString } from "./constants";
import { useResolveLocalizedString } from "./useResolveLocalizedString";

export function LocalizedStringPreview({
  value,
  size,
}: PropertyPreviewProps<LocalizedString>) {
  const resolveLocalizedString = useResolveLocalizedString();
  const text = resolveLocalizedString(value);
  const className =
    size === "small"
      ? "text-xs truncate"
      : size === "large"
        ? "text-base"
        : "text-sm truncate";

  return <span className={className}>{text || "—"}</span>;
}
